const Pages = Object.freeze({
  DOMAIN_SELECT: 1,
  DOMAIN_ADD: 2,
  COMPLETE_SETUP: 3
});

export default Pages;
